<script>
import CChart from '@/components/common/CChart.vue'

export default Object.assign({}, CChart, {
  name: 'CChartBar',
  type: 'bar',
})
</script>
